import React, { Fragment } from "react";
import { connect } from "react-redux";
import { ApplicationState, ConnectedReduxProps } from "@reducers/index";
import { Tag } from "@models/tag";
import { deleteRequest, fetchRequest } from "@actions/tag";
import TagForm from "@components/tags/Form";
import { createRequest, updateRequest } from "@actions/tag";
import tagApi from "@api/tag";
import { injectIntl } from "react-intl";

interface PropsFromState {
  loading: boolean;
  data: Tag[];
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest;
  deleteRequest: typeof deleteRequest;
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class TagFormPage extends React.Component<AllProps> {
  state = {
    tag: null,
    tag_id: this.props.match.params.id,
    is_fetched: false
  };

  componentDidMount() {
    if (this.state.tag_id) {
      this.fetchItem();
    }
  }

  fetchItem = () => {
    tagApi
      .getItem({
        params: {
          id: this.state.tag_id
        }
      })
      .then(({ data }) => {
        this.setState({
          tag: data
        });
      })
      .catch(error => console.log(error));
  };

  getContent = () => {
    if (this.state.tag_id && !this.state.tag) {
      return null;
    }

    return (
      <TagForm
        tag={this.state.tag}
        intl={this.props.intl}
        listUrl={"/tags"}
        history={this.props.history}
        updateRequest={this.props.updateRequest}
        createRequest={this.props.createRequest}
      />
    );
  };

  render() {
    return <Fragment>{this.getContent()}</Fragment>;
  }
}

const mapStateToProps = ({ tags }: ApplicationState) => ({
  loading: tags.loading,
  errors: tags.errors
});

const mapDispatchToProps = {
  createRequest,
  updateRequest
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(TagFormPage));
